export declare namespace AppEmptyStateTokenSections {
	interface IconWrap {
		size: string;
		padding: string;
		borderRadius: string;
		background: string;
		color: string;
	}

	interface IconGlyph {
		fontSize: string;
	}

	interface Title {
		color: string;
		fontSize: string;
		fontWeight: string;
		lineHeight: string;
	}

	interface Description {
		color: string;
		fontSize: string;
		fontWeight: string;
		lineHeight: string;
	}
}

export type AppEmptyStateTokens = {
	padding: string;
	background: string;
	borderColor: string;
	iconWrap: AppEmptyStateTokenSections.IconWrap;
	iconGlyph: AppEmptyStateTokenSections.IconGlyph;
	title: AppEmptyStateTokenSections.Title;
	description: AppEmptyStateTokenSections.Description;
};

export const iconWrap: AppEmptyStateTokenSections.IconWrap = {
	size: '2.5rem',
	padding: '2.86px',
	borderRadius: '{border.radius.sm}',
	background: '{primary.50}',
	color: '{primary.500}',
};

export const iconGlyph: AppEmptyStateTokenSections.IconGlyph = {
	fontSize: '2.125rem',
};

/** Title/Title 40 */
export const title: AppEmptyStateTokenSections.Title = {
	color: '{primary.500}',
	fontSize: '18px',
	fontWeight: '700',
	lineHeight: '30px',
};

/** Body/Body 30 */
export const description: AppEmptyStateTokenSections.Description = {
	color: '{surface.400}',
	fontSize: '16px',
	fontWeight: '400',
	lineHeight: '26px',
};

/** Empty-state card shown in place of a list (Figma 15389:35945 events tab, 15389:31656 previous reports tab). */
export default {
	padding: '32px',
	background: '{content.background}',
	borderColor: '{surface.100}',
	iconWrap,
	iconGlyph,
	title,
	description,
} satisfies AppEmptyStateTokens;
